import { CageDrawingPropertyDto } from 'models/mooring';
import { BuoyMappedForDrawing } from '../buoy';
import { Coordinate } from 'ol/coordinate';

type CageOutput = {
  Id: number;
  Row: number;
  Column: number;
  Diameter: number;
  MoorlogNo: string;
  AnalysisNo: string;
  Center: Coordinate;
};

/**
 * Calculate cage positions in the center of each buoy cell
 *
 * This function assumes that each cage is positioned at the center of a 2x2 grid of buoys.
 * It calculates the center coordinate of each cell formed by 4 buoys and returns an array
 * of cage positions with their properties.
 */
export function calculateCagePositions(grid: BuoyMappedForDrawing[][], cages: CageDrawingPropertyDto[]) {
  const cagePositions: CageOutput[] = [];

  if (!grid.length || !grid[0].length) {
    return cagePositions;
  }
  const rows = grid.length;
  const cols = grid[0].length;

  // Each cage is in the center of a cell formed by 4 buoys
  for (let row = 0; row < rows - 1; row++) {
    for (let col = 0; col < cols - 1; col++) {
      // Get the 4 corner buoys of this cell
      const topLeft = grid[row][col].Center;
      const topRight = grid[row][col + 1].Center;
      const bottomLeft = grid[row + 1][col].Center;
      const bottomRight = grid[row + 1][col + 1].Center;

      // Calculate center point of the cell
      const centerLon = (topLeft[0] + topRight[0] + bottomLeft[0] + bottomRight[0]) / 4;
      const centerLat = (topLeft[1] + topRight[1] + bottomLeft[1] + bottomRight[1]) / 4;

      const cage = cages.find((c) => c.Row === row + 1 && c.Column === col + 1);
      if (!cage) continue;

      cagePositions.push({
        Id: cage.Id,
        Row: cage.Row,
        Column: cage.Column,
        MoorlogNo: cage.MooringNo,
        AnalysisNo: cage.AnalysisNo,
        Diameter: cage.PenCircumference,
        Center: [centerLon, centerLat],
      });
    }
  }

  return cagePositions;
}
